import { component, prop } from '../../../../decorators';

import Tag from '../../../../components/common/tag/tag.vue';

@component({
   components: { Tag }
})
export default class KeyBoundItem {
   @prop({ type: Number, required: true }) code
   @prop({ type: String, required: true }) label
   @prop({ type: String, default: '' }) desc
   @prop({ type: Boolean, default: false }) disabled
   @prop({ type: Boolean, default: true }) canRemove

   get letter() {
      return String.fromCharCode(this.code);
   }

   onClick() {
      if ( !this.disabled ) {
         this.$emit('click', this.code);
      }
   }
}
